import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicCFG = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Context-Free Grammar (CFG) in TOC"
      videos={[
        "https://www.youtube.com/embed/JxRWgobTYto",
        "https://www.youtube.com/embed/YX95TqVvMyo",
      ]}
      takeaways={[
        { text: "Be clear about the definition of CFG and practice as many questions as possible on constructing CFG." },
        { text: "Mostly, 5-mark or fewer questions appear from this topic." },
      ]}
      questions={[
        {text:"Write Context-Free Grammar (CFG) for the given language and check if the grammar is ambiguous or not. L = {a^n b^n+m c^m | n, m ≥ 0}."},
        {text:"Construct a CFG for the language L = {(01)^n} U {(10)^n / n≥1}."},
        {text:"Construct context-free grammar for the language: L = {abba(baa)^n aab(aaba)^n | n ≥ 0}."},
        {text:"Design a CFG for the given language Y = {a^n b^m a^2n : n, m ≥ 0}."},
        {text:"Consider the grammar S → 0S1 | 1S0 | λ. Does it generate the language L2 = {w: |w|0 = |w|1}? If not, justify and suggest modifications."},
        {text:"Derive the CFG for the given Context-Free Language and check the ambiguity: L = {v^r i^r+s t^s | r, s ≥ 0}."},
        {text:"Design a CFG for L = {wwRzzR | w, z ∈ {0,1}+, 011 is a substring of w, and |z| is odd}. Explain each production rule."},
        {text:"Design a CFG that generates regular expressions with terminals T = {0,1,(,),U,*,ϕ,ε}. Check if w = (0 U(10)*1)* is accepted by the CFG."},
      ]}
      exampleVideos={[
        "https://www.youtube.com/embed/4DBG-6Jvyko",
        "https://www.youtube.com/embed/kbyXZmCfrGk",
        "https://www.youtube.com/embed/fG7TWr9Fyng",
      ]}
    />
  );
}

export { ModuleSubtopicCFG };
